import { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import axiosInstance from '../axiosConfig';
import ListaProdutos from '../components/ListaProdutos';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { useNavigate } from 'react-router-dom';
import Input from '../components/Input';
import { handleError } from '../services/handleError';
import { showToast } from '../components/Toast';
import Loading from "./Loading";
import { formatValue } from '../utils/formatValue';

export default function NovoPedido() {
    const navigate = useNavigate();
    const [selected, setSelected] = useState(null);
    const [mesas, setMesas] = useState([]);
    const [opcoesPedido, setOpcoesPedido] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [mesaSelecionada, setMesaSelecionada] = useState();
    const [produtosSelecionados, setProdutosSelecionados] = useState([]);
    const [etapa, setEtapa] = useState(0);
    const [loading, setLoading] = useState(false);
    const inputNomeRetirada = useRef(null);
    const inputTelefoneRetirada = useRef(null);
    const [nomeDelivery, setNomeDelivery] = useState('');
    const [telefoneDelivery, setTelefoneDelivery] = useState('');
    const [formaPagamento, setFormaPagamento] = useState('');
    const [cepDelivery, setCepDelivery] = useState('');
    const inputLogradouroDelivery = useRef(null);
    const inputNumeroDelivery = useRef(null);
    const inputComplementoDelivery = useRef(null);
    const inputBairroDelivery = useRef(null);
    const inputCidadeDelivery = useRef(null);
    const inputEstadoDelivery = useRef(null);

    const [endereco, setEndereco] = useState({
        logradouro: '',
        bairro: '',
        cidade: '',
        estado: ''
    });

    useEffect(() => {
        buscarOpcoesEntrega();
    }, []);

    async function buscarOpcoesEntrega() {
        setLoading(true);

        try {
            const response = await axiosInstance.get("Configs/OpcoesPedido");

            setOpcoesPedido(response.data)
        } catch (error) {
            handleError(error, "Erro ao buscar opções de pedido.");
        } finally {
            setLoading(false);
        }
    };

    const getSquareStyles = (option) =>
        `cursor-pointer transition-all duration-500 ${selected
            ? 'w-full h-12'
            : 'w-80 h-32 sm:h-80'
        } flex items-center justify-center border-2 rounded-lg ${selected === option ? 'border-blue-500 bg-blue-100' : 'border-gray-300'
        }`;

    async function buscarMesas() {
        setLoading(true);

        try {
            const response = await axiosInstance.get("Mesas");

            setMesas(response.data)
        } catch (error) {
            handleError(error, "Erro ao buscar mesas.");
        } finally {
            setLoading(false);
        }
    };

    async function buscarProdutos() {
        setLoading(true);

        try {
            const response = await axiosInstance.get("Produto/GetProdutos");

            setProdutos(response.data)
        } catch (error) {
            handleError(error, "Erro ao buscar produtos.");
        } finally {
            setLoading(false);
        }
    };

    const buscarEnderecoPorCep = async () => {
        const cep = cepDelivery.replace(/\D/g, '');
        if (cep.length === 8) {
            setLoading(true);

            try {
                const response = await axiosInstance.get(`https://viacep.com.br/ws/${cep}/json/`);
                const data = response.data;

                if (!data.erro) {
                    // Atualiza o estado com os dados do endereço
                    setEndereco({
                        logradouro: data.logradouro,
                        bairro: data.bairro,
                        cidade: data.localidade,
                        estado: data.uf
                    });
                } else {
                    setEndereco({ logradouro: '', bairro: '', cidade: '', estado: '' });
                    handleError("CEP não encontrado");
                }
            } catch (error) {
                handleError("Erro ao buscar o endereço. Verifique o CEP e tente novamente.");
            } finally {
                setLoading(false);
            }
        } else {
            handleError("CEP inválido. O CEP deve conter 8 dígitos.");
        }
    };

    const handleConfirmarPedidoMesa = async () => {
        if (produtosSelecionados.length === 0)
            return handleError("Selecione um produto!");

        produtosSelecionados.forEach(produto => {
            produto.MetadeProdutoId = produto.produto.MetadeProdutoId;
            produto.Adicionais = produto.produto.adicionais
                ?.filter(a => a.adicionado)
                .map(a => a.id)
                .join(",") || "";
        });

        try {
            await axiosInstance.post("Pedidos/AddProdutosMesa", { MesaId: mesaSelecionada.id, Produtos: produtosSelecionados });
            showToast("Sucesso!", "success", 3000, "Pedido confirmado com sucesso");
            return navigate("/");
        } catch (error) {
            handleError(error, "Erro ao adicionar.");
        } finally {
            setLoading(false);
        }
    };

    const handleConfirmarPedidoRetirada = async () => {
        if (produtosSelecionados.length === 0)
            return handleError("Selecione um produto!");

        let nomeCliente = inputNomeRetirada.current.value;
        let telefoneCliente = inputTelefoneRetirada.current.value;

        if (nomeCliente.trim() === "") {
            return handleError("Por favor, informe o nome do cliente.");
        }

        const apenasDigitos = telefoneCliente.replace(/\D/g, '');
        if (
            !apenasDigitos ||                                     // Valida se está em branco ou não contém números
            apenasDigitos.length < 10 ||                          // Valida se tem MENOS de 10 dígitos
            new Set(apenasDigitos).size === 1                     // Valida se todos os dígitos são repetidos
        ) {
            return handleError("O número de telefone é inválido.");
        }

        let produtosFormatados = produtosSelecionados.map(objeto => ({
            MetadeProdutoId: objeto.produto.MetadeProdutoId,
            PorKg: objeto.produto.porKg,
            ProdutoId: objeto.produto.id,
            Quantidade: objeto.quantidade,
            Valor: objeto.produto.valor,
            Observacao: objeto.observacao,
            Adicionais: JSON.stringify(objeto?.produto?.adicionais?.filter(adicional => adicional.adicionado).map(adicional => adicional.id)),
            perguntas: objeto?.perguntas?.map(p => ({
                perguntaId: p.PerguntaId,
                opcaoId: p.OpcaoId,
            })) || []
        }));

        setLoading(true);

        try {
            await axiosInstance.post("Pedidos/AddRetirada", { Produtos: produtosFormatados, NomeCliente: nomeCliente, Telefone: telefoneCliente.replace(/\D/g, ''), formaPagamento });
            showToast("Sucesso!", "success", 3000, "Pedido confirmado com sucesso");
            return navigate("/");
        } catch (error) {
            handleError(error, "Erro ao criar pedido.");
        } finally {
            setLoading(false);
        }
    };

    const handleConfirmarPedidoDelivery = async () => {
        if (produtosSelecionados.length === 0)
            return handleError("Selecione um produto!");

        let nomeCliente = nomeDelivery;
        let telefoneCliente = telefoneDelivery;
        let logradouroCliente = inputLogradouroDelivery.current.value;
        let numeroCliente = inputNumeroDelivery.current.value;
        let complementoCliente = inputComplementoDelivery.current.value;
        let bairroCliente = inputBairroDelivery.current.value;
        let cidadeCliente = inputCidadeDelivery.current.value;
        let estadoCliente = inputEstadoDelivery.current.value;
        let cepCliente = cepDelivery;

        if (nomeCliente.trim() === "") {
            return handleError("Por favor, informe o nome do cliente.");
        }

        const apenasDigitos = telefoneCliente.replace(/\D/g, '');
        if (
            !apenasDigitos ||                                     // Valida se está em branco ou não contém números
            apenasDigitos.length < 10 ||                          // Valida se tem MENOS de 10 dígitos
            new Set(apenasDigitos).size === 1                     // Valida se todos os dígitos são repetidos
        ) {
            return handleError("O número de telefone é inválido.");
        }

        if (logradouroCliente.trim() === "")
            return handleError("Informe o logradouro do cliente!");

        if (numeroCliente.trim() === "")
            return handleError("Informe o número do cliente!");

        if (bairroCliente.trim() === "")
            return handleError("Informe o bairro do cliente!");

        if (cidadeCliente.trim() === "")
            return handleError("Informe o cidade do cliente!");

        let produtosFormatados = produtosSelecionados.map(objeto => ({
            MetadeProdutoId: objeto.produto.MetadeProdutoId,
            PorKg: objeto.produto.porKg,
            ProdutoId: objeto.produto.id,
            Quantidade: objeto.quantidade,
            Valor: objeto.produto.valor,
            Observacao: objeto.observacao,
            Adicionais: JSON.stringify(objeto?.produto?.adicionais?.filter(adicional => adicional.adicionado).map(adicional => adicional.id)),
            perguntas: objeto?.perguntas?.map(p => ({
                perguntaId: p.PerguntaId,
                opcaoId: p.OpcaoId,
            })) || []
        }));

        let cliente = {
            nome: nomeCliente,
            telefone: telefoneCliente.replace(/\D/g, ''),
            logradouro: logradouroCliente,
            numero: numeroCliente,
            complemento: complementoCliente,
            bairro: bairroCliente,
            cidade: cidadeCliente,
            estado: estadoCliente,
            cep: cepCliente,
        }

        setLoading(true);

        try {
            await axiosInstance.post("Pedidos/AddDelivery", { Produtos: produtosFormatados, Cliente: cliente, formaPagamento });
            showToast("Sucesso!", "success", 3000, "Pedido criado com sucesso");
            return navigate("/");
        } catch (error) {
            handleError(error, "Erro ao criar pedido.");
        } finally {
            setLoading(false);
        }
    };

    const handleAddProduct = (item, quantidade, observacao) => {
        const novoProduto = {
            produto: {
                MetadeProdutoId: item.metade,
                id: item.id,
                url_Imagem: item.url_Imagem,
                titulo: item.titulo,
                valor: item.valor,
                adicionais: item.adicionais,
                porKg: item.porKg
            },
            perguntas: item.perguntas,
            quantidade,
            observacao
        };

        setProdutosSelecionados(prevProdutos => [...prevProdutos, novoProduto]);
    };

    const handleRemoveProduct = (index) => {
        setProdutosSelecionados(prevProdutos =>
            prevProdutos.filter((_, i) => i !== index)
        );
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="p-2 py-4 sm:p-5">
            <div className="flex justify-center gap-2 sm:gap-8 mb-5">
                {opcoesPedido.atendeBalcao &&
                    <div
                        className={getSquareStyles('presencial')}
                        onClick={() => { setSelected('presencial'); buscarMesas(); setEtapa(1); setMesaSelecionada(); }}
                    >
                        <span className="text-lg">Mesas</span>
                    </div>
                }

                {opcoesPedido.atendeRetirada &&
                    <div
                        className={getSquareStyles('retirada')}
                        onClick={() => { setSelected('retirada'); setEtapa(1); buscarProdutos(); }}
                    >
                        <span className="text-lg">Retirada</span>
                    </div>
                }

                {opcoesPedido.atendeEntrega &&
                    <div
                        className={getSquareStyles('delivery')}
                        onClick={() => { setSelected('delivery'); setEtapa(1); buscarProdutos(); }}
                    >
                        <span className="text-lg">Delivery</span>
                    </div>
                }

                {(!opcoesPedido.atendeBalcao && !opcoesPedido.atendeRetirada && !opcoesPedido.atendeEntrega) &&
                    <span>Você ainda não habilitou nenhum método de pedido. Vá até as configurações e selecione pelo menos uma opção para que seus clientes possam fazer pedidos.</span>
                }
            </div>


            {selected === "presencial" &&
                <>
                    <div className="w-full border rounded-[10px] h-16 sm:h-12 items-center flex justify-between px-1 sm:px-2 mb-4">
                        <FontAwesomeIcon icon={faArrowLeft} className="mr-2 fa-xl border p-1 rounded cursor-pointer" onClick={() => etapa === 3 ? setEtapa(2) : etapa === 2 ? setEtapa(1) : ''} />

                        {etapa === 1 && <span className='font-regular sm:text-xl'>Selecione a Mesa</span>}
                        {etapa === 2 && <span className='font-regular sm:text-xl'>Selecione os Produtos</span>}
                        {etapa === 3 && <span className='font-regular sm:text-xl'>Confirme os Produtos</span>}

                        <button
                            disabled={mesaSelecionada === undefined || produtosSelecionados.length === 0}
                            onClick={() => etapa !== 3 ? setEtapa(3) : handleConfirmarPedidoMesa()}
                            className={`py-1 text-white font-regular px-2 sm:px-4 rounded-lg 
                                bg-blue-700 hover:bg-blue-800 active:bg-blue-900 
                                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 
                                shadow-md transition-all duration-200 ease-in-out 
                                transform hover:scale-105 active:scale-95 whitespace-nowrap
                                ${mesaSelecionada === undefined || produtosSelecionados.length === 0 ? 'opacity-50 cursor-not-allowed hover:scale-100' : ''}`}
                        >
                            {etapa === 3 ? "Confirmar" : "Continuar"}
                        </button>
                    </div>

                    {etapa === 1 && // Seleciona Mesa
                        <div className="flex flex-wrap gap-4">
                            {mesas.map((mesa) => (
                                <div
                                    key={mesa.id}
                                    className={`select-none hover:scale-105 shadow-md transition-all duration-200 ease-in-out transform active:scale-95 cursor-pointer rounded-[10px] w-32 h-24 text-white items-center justify-center flex ${mesa.ocupada ? "bg-red-600" : "bg-green-600"}`}
                                    onClick={() => { setMesaSelecionada(mesa); setEtapa(2); buscarProdutos() }}
                                >
                                    Mesa {mesa.numero}
                                </div>
                            ))}
                        </div>
                    }

                    {etapa === 2 && // Escolhe produtos
                        <>
                            <ListaProdutos produtos={produtos} onAddProduct={handleAddProduct} />
                        </>
                    }

                    {etapa === 3 && // Confirma itens
                        <>
                            {produtosSelecionados.map((produto, index) => (
                                <div key={index} className="flex space-x-2 border justify-between rounded-[10px] py-2 px-4 mb-2">
                                    <div className="flex items-center space-x-4">
                                        <img src={produto.produto.url_Imagem} alt="Img Produto" className="w-24 h-20 rounded-[10px] object-cover" />
                                        <div className="grid">
                                            <span className="text-lg font-medium">
                                                {produto.quantidade} {produto.produto.porKg ? "kg" : "un"} - {produto.produto.titulo}
                                            </span>

                                            {produto?.produto?.adicionais?.some(adicional => adicional.adicionado) && (
                                                <span className='block text-md font-normal'>
                                                    Acompanhamentos: {produto.produto.adicionais.filter(a => a.adicionado).map(a => a.nome).join(", ")}
                                                </span>
                                            )}
                                            {produto?.observacao && (
                                                <span className="block text-md font-normal">
                                                    Observação: {produto.observacao}
                                                </span>
                                            )}

                                            {produto?.perguntas?.length > 0 && (
                                                <>
                                                    {produto.perguntas.map((p) => (
                                                        <span key={p.PerguntaId} className="block text-md font-normal">
                                                            {p.TextoPergunta}: {p.TextoResposta}
                                                            {p.ValorExtra > 0 && ` (+${formatValue(p.ValorExtra)})`}
                                                        </span>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="space-x-2 flex items-center">
                                        <button className="w-10 py-2 bg-red-500 hover:bg-red-600 active:bg-red-700 text-white rounded-[10px]">
                                            <FontAwesomeIcon icon={faTrash} onClick={() => handleRemoveProduct(index)} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                </>
            }

            {selected === "retirada" &&
                <>
                    <div className="w-full border rounded-[10px] h-16 sm:h-12 items-center flex justify-between px-1 sm:px-2 mb-4">
                        <FontAwesomeIcon icon={faArrowLeft} className="mr-2 fa-xl border p-1 rounded cursor-pointer" onClick={() => etapa === 3 ? setEtapa(2) : etapa === 2 ? setEtapa(1) : ''} />

                        {etapa === 1 && <span className='font-regular sm:text-xl'>Selecione os Produtos</span>}
                        {etapa === 2 && <span className='font-regular sm:text-xl'>Confirme os Produtos</span>}
                        {etapa === 3 && <span className='font-regular sm:text-xl'>Dados do Cliente</span>}

                        <button
                            disabled={produtosSelecionados.length === 0}
                            onClick={() => etapa === 1 ? setEtapa(2) : etapa === 3 ? handleConfirmarPedidoRetirada() : setEtapa(3)}
                            className={`py-1 text-white font-regular px-2 sm:px-4 rounded-lg 
                                bg-blue-700 hover:bg-blue-800 active:bg-blue-900 
                                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 
                                shadow-md transition-all duration-200 ease-in-out 
                                transform hover:scale-105 active:scale-95 whitespace-nowrap
                                ${produtosSelecionados.length === 0 ? 'opacity-50 cursor-not-allowed hover:scale-100' : ''}`}
                        >
                            {etapa === 3 ? "Confirmar" : "Continuar"}
                        </button>
                    </div>

                    {etapa === 1 && // Escolhe produtos
                        <>
                            <ListaProdutos produtos={produtos} onAddProduct={handleAddProduct} />
                        </>
                    }
                    {etapa === 2 && // Confirma itens
                        <>
                            {produtosSelecionados.map((produto, index) => (
                                <div key={index} className="flex space-x-2 border justify-between rounded-[10px] py-2 px-4 mb-2">
                                    <div className="flex items-center space-x-4">
                                        <img src={produto.produto.url_Imagem} alt="Img Produto" className="w-24 h-20 rounded-[10px] object-cover" />
                                        <div className="grid">
                                            <span className="text-lg font-medium">
                                                {produto.quantidade} {produto.produto.porKg ? "kg" : "un"} - {produto.produto.titulo}
                                            </span>
                                            {produto?.produto?.adicionais?.some(adicional => adicional.adicionado) && (
                                                <span className='block text-md font-normal'>
                                                    Acompanhamentos: {produto.produto.adicionais.filter(a => a.adicionado).map(a => a.nome).join(", ")}
                                                </span>
                                            )}
                                            {produto?.observacao && (
                                                <span className="block text-md font-normal">
                                                    Observação: {produto.observacao}
                                                </span>
                                            )}
                                            {produto?.perguntas?.length > 0 && (
                                                <>
                                                    {produto.perguntas.map((p) => (
                                                        <span key={p.PerguntaId} className="block text-md font-normal">
                                                            {p.TextoPergunta}: {p.TextoResposta}
                                                            {p.ValorExtra > 0 && ` (+${formatValue(p.ValorExtra)})`}
                                                        </span>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="space-x-2 flex items-center">
                                        <button className="w-10 py-2 bg-red-500 hover:bg-red-600 active:bg-red-700 text-white rounded-[10px]">
                                            <FontAwesomeIcon icon={faTrash} onClick={() => handleRemoveProduct(index)} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                    {etapa === 3 && // Dados entrega
                        <>
                            <div className="mt-6 space-y-2 w-full text-center">
                                <Input placeholder="Informe o Nome" size="medium" referencia={inputNomeRetirada} />
                                <Input placeholder="Informe o Telefone" size="medium" type="tel" referencia={inputTelefoneRetirada} />

                                <div className="mt-2">
                                    <select
                                        value={formaPagamento}
                                        onChange={(e) => setFormaPagamento(e.target.value)}
                                        className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:outline-none bg-white text-gray-700"
                                    >
                                        <option value="">Selecione a forma de pagamento</option>
                                        <option value="Dinheiro">Dinheiro</option>
                                        <option value="Pix">Pix</option>
                                        <option value="Cartão de Débito">Cartão de Débito</option>
                                        <option value="Cartão de Crédito">Cartão de Crédito</option>
                                        <option value="Outro">Outro</option>
                                    </select>
                                </div>
                            </div>
                        </>
                    }
                </>
            }

            {selected === "delivery" &&
                <>
                    <div className="w-full border rounded-[10px] h-16 sm:h-12 items-center flex justify-between px-1 sm:px-2 mb-4">
                        <FontAwesomeIcon icon={faArrowLeft} className="mr-2 fa-xl border p-1 rounded cursor-pointer" onClick={() => etapa === 3 ? setEtapa(2) : etapa === 2 ? setEtapa(1) : ''} />

                        {etapa === 1 && <span className='font-regular sm:text-xl'>Selecione os Produtos</span>}
                        {etapa === 2 && <span className='font-regular sm:text-xl'>Confirme os Produtos</span>}
                        {etapa === 3 && <span className='font-regular sm:text-xl'>Dados de Entrega</span>}

                        <button
                            disabled={produtosSelecionados.length === 0}
                            onClick={() => etapa === 1 ? setEtapa(2) : etapa === 3 ? handleConfirmarPedidoDelivery() : setEtapa(3)}
                            className={`py-1 text-white font-regular px-2 sm:px-4 rounded-lg 
                                bg-blue-700 hover:bg-blue-800 active:bg-blue-900 
                                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 
                                shadow-md transition-all duration-200 ease-in-out 
                                transform hover:scale-105 active:scale-95 whitespace-nowrap
                                ${produtosSelecionados.length === 0 ? 'opacity-50 cursor-not-allowed hover:scale-100' : ''}`}
                        >
                            {etapa === 3 ? "Confirmar" : "Continuar"}
                        </button>
                    </div>

                    {etapa === 1 && // Escolhe produtos
                        <>
                            <ListaProdutos produtos={produtos} onAddProduct={handleAddProduct} />
                        </>
                    }
                    {etapa === 2 && // Confirma itens
                        <>
                            {produtosSelecionados.map((produto, index) => (
                                <div key={index} className="flex space-x-2 border justify-between rounded-[10px] py-2 px-4 mb-2">
                                    <div className="flex items-center space-x-4">
                                        <img src={produto.produto.url_Imagem} alt="Img Produto" className="w-24 h-20 rounded-[10px] object-cover" />
                                        <div className="grid">
                                            <span className="text-lg font-medium">
                                                {produto.quantidade} {produto.produto.porKg ? "kg" : "un"} - {produto.produto.titulo}
                                            </span>
                                            {produto?.produto?.adicionais?.some(adicional => adicional.adicionado) && (
                                                <span className='block text-md font-normal'>
                                                    Acompanhamentos: {produto.produto.adicionais.filter(a => a.adicionado).map(a => a.nome).join(", ")}
                                                </span>
                                            )}
                                            {produto?.observacao && (
                                                <span className="block text-md font-normal">
                                                    Observação: {produto.observacao}
                                                </span>
                                            )}
                                            {produto?.perguntas?.length > 0 && (
                                                <>
                                                    {produto.perguntas.map((p) => (
                                                        <span key={p.PerguntaId} className="block text-md font-normal">
                                                            {p.TextoPergunta}: {p.TextoResposta}
                                                            {p.ValorExtra > 0 && ` (+${formatValue(p.ValorExtra)})`}
                                                        </span>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="space-x-2 flex items-center">
                                        <button className="w-10 py-2 bg-red-500 hover:bg-red-600 active:bg-red-700 text-white rounded-[10px]">
                                            <FontAwesomeIcon icon={faTrash} onClick={() => handleRemoveProduct(index)} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                    {etapa === 3 && // Dados entrega
                        <>
                            <div className="mt-6 space-y-4 w-full text-center">
                                {/* Nome */}
                                <Input
                                    placeholder="Informe o Nome"
                                    size="medium"
                                    value={nomeDelivery}
                                    onChange={(e) => setNomeDelivery(e)}
                                    className="w-full"
                                />

                                <div className="flex space-x-4">
                                    <Input
                                        placeholder="Informe o Telefone"
                                        size="medium"
                                        type="tel"
                                        value={telefoneDelivery}
                                        onChange={(e) => setTelefoneDelivery(e)}
                                        className="w-1/2"
                                    />
                                    <Input
                                        placeholder="Informe o CEP"
                                        size="medium"
                                        type="cep"
                                        value={cepDelivery}
                                        onChange={(e) => setCepDelivery(e)}
                                        className="w-1/2"
                                        onBlur={() => buscarEnderecoPorCep()}
                                    />
                                </div>

                                <div className="flex space-x-4">
                                    <Input
                                        placeholder="Informe o Logradouro"
                                        size="medium"
                                        value={endereco.logradouro}
                                        referencia={inputLogradouroDelivery}
                                        className="w-1/2"
                                    />
                                    <Input
                                        placeholder="Número"
                                        size="medium"
                                        type="text"
                                        referencia={inputNumeroDelivery}
                                        className="w-1/2"
                                    />
                                </div>

                                <div className="flex space-x-4">
                                    <Input
                                        placeholder="Complemento"
                                        size="medium"
                                        referencia={inputComplementoDelivery}
                                        className="w-1/2"
                                    />
                                    <Input
                                        placeholder="Bairro"
                                        size="medium"
                                        referencia={inputBairroDelivery}
                                        className="w-1/2"
                                        value={endereco.bairro}
                                    />
                                </div>

                                <div className="flex space-x-4">
                                    <Input
                                        placeholder="Cidade"
                                        size="medium"
                                        referencia={inputCidadeDelivery}
                                        className="w-1/2"
                                        value={endereco.cidade}
                                    />
                                    <Input
                                        placeholder="Estado"
                                        size="medium"
                                        referencia={inputEstadoDelivery}
                                        value={endereco.estado}
                                        className="w-1/2"
                                    />
                                </div>
                                <div className="mt-2">
                                    <select
                                        value={formaPagamento}
                                        onChange={(e) => setFormaPagamento(e.target.value)}
                                        className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:outline-none bg-white text-gray-700"
                                    >
                                        <option value="">Selecione a forma de pagamento</option>
                                        <option value="Dinheiro">Dinheiro</option>
                                        <option value="Pix">Pix</option>
                                        <option value="Cartão de Débito">Cartão de Débito</option>
                                        <option value="Cartão de Crédito">Cartão de Crédito</option>
                                        <option value="Outro">Outro</option>
                                    </select>
                                </div>
                                <div className="text-end">
                                    Taxa de Entrega: {formatValue(opcoesPedido.taxaEntrega)}
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </div>
    );
}
